export class TipoProdutoEnum {
  public static FINANCIMENTO = 'CDC';
  public static REFINANCIAMENTO = 'REFINANCIAMENTO';
  public static CDC_LOJA = 'CDC_LOJA';
  public static CREDITO_PESSOAL = 'CREDITO_PESSOAL';
  public static MICROCREDITO = 'MICROCREDITO';
  public static LEADS = 'LEADS';
}
